// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Din","fullView":"styles_fullView__15wMU"};